/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_Sales_Range_DeductedInputs */

const en_cargos_sales_range_deducted = /** @type {(inputs: Cargos_Sales_Range_DeductedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sold`)
};

const es_cargos_sales_range_deducted = /** @type {(inputs: Cargos_Sales_Range_DeductedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendidos`)
};

/**
* | output |
* | --- |
* | "Sold" |
*
* @param {Cargos_Sales_Range_DeductedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_sales_range_deducted = /** @type {((inputs?: Cargos_Sales_Range_DeductedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_Sales_Range_DeductedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_sales_range_deducted(inputs)
	return es_cargos_sales_range_deducted(inputs)
});